import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import { useForm } from 'hooks/useForm';
import { createTransaction } from '@redux/features/transactionsSlice';
import { getCashbox } from '@redux/features/cashboxesSlice';
import { getTransactionSchema } from 'constants/formValidationSchemas/transactionSchema';
import { transactionsTypesTranslations } from 'constants/transactionTypes';
import { TabSelector } from 'components/TabSelector';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import { Modal } from 'components/Modal';
import styles from './CashboxPage.scss';

const defaultValues = {
  type: Object.keys(transactionsTypesTranslations)[0],
  description: '',
  amount: '',
};

export const CreateTransaction = ({ cashboxID, isOpen, setIsOpen }) => {
  const { paymentMethods } = useSelector((state) => state.paymentMethods);
  const [resetCounter, setResetCounter] = useState(0);
  const dispatch = useDispatch();

  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    resetForm,
    setFieldValue,
    isValid,
  } = useForm({
    initialValues: defaultValues,
    validationSchema: getTransactionSchema(paymentMethods, true),
    onSubmit: async (values) => {
      await dispatch(createTransaction({ cashboxID, method: 'cash', ...values }));
      dispatch(getCashbox(cashboxID));
      setResetCounter((prev) => prev + 1);
      resetForm();
      setIsOpen(false);
    },
  });

  const handleTypeChange = (index) => {
    const typeKey = Object.keys(transactionsTypesTranslations)[index];
    setFieldValue('type', typeKey);
  };

  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
      <h3>Створити нову транзакцію</h3>
      <form onSubmit={handleSubmit}>
        <TabSelector
          tabs={Object.values(transactionsTypesTranslations)}
          onTabChange={handleTypeChange}
          resetTrigger={resetCounter}
        />
        <Input
          placeholder='Опис'
          name='description'
          value={values.description}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={touched.description && errors.description}
          errorText={touched.description && errors.description}
        />
        <Input
          placeholder='Сума'
          name='amount'
          type='number'
          step='100'
          value={values.amount}
          onChange={handleChange}
          onBlur={handleBlur}
          invalid={touched.amount && errors.amount}
          errorText={touched.amount && errors.amount}
        />
        <div className={styles.formButtons}>
          <Button
            className={styles.btn}
            text='Скинути'
            type='reset'
            onClick={() => {
              resetForm();
              setResetCounter((prev) => prev + 1);
            }}
            ghostStyle
          />
          <Button className={styles.formBtn} text='Створити' type='submit' disabled={!isValid || isSubmitting} />
        </div>
      </form>
    </Modal>
  );
};
